var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBoxRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.62 13.2 2.79 8.09a.752.752 0 0 1-.27-1.03c.21-.36.67-.48 1.02-.27l8.45 4.89 8.4-4.86c.36-.21.82-.08 1.02.27.21.36.08.82-.27 1.03l-8.77 5.08a.746.746 0 0 1-.75 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.61v-9.07c0-.41.34-.75.75-.75s.75.34.75.75v9.07c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.559 22.17-5.34-2.96c-1.45-.8-2.59-2.73-2.59-4.39V9.16c0-1.66 1.14-3.58 2.59-4.39l5.34-2.96c1.36-.77 3.5-.77 4.87 0l5.34 2.96c1.45.8 2.59 2.73 2.59 4.39v5.66c0 .1 0 .18-.02.28-.05.26-.24.48-.49.56-.25.09-.53.03-.74-.14-1.15-1-2.93-1.04-4.14-.07a3.224 3.224 0 0 0-.75 4.2c.08.14.16.25.25.36a.738.738 0 0 1-.21 1.14l-1.83 1.01c-.68.4-1.55.59-2.43.59-.88 0-1.76-.19-2.44-.58zm.74-19.04-5.34 2.96c-.97.53-1.81 1.97-1.81 3.07v5.66c0 1.1.85 2.54 1.81 3.07l5.34 2.96c.91.51 2.5.51 3.41 0l1.12-.62a4.67 4.67 0 0 1-.57-2.25c0-1.46.65-2.81 1.78-3.71 1.36-1.09 3.31-1.32 4.83-.67V9.14c0-1.1-.85-2.54-1.81-3.07l-5.34-2.96c-.47-.23-1.1-.36-1.72-.36-.62 0-1.25.13-1.7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.94 20.44c-.45-.72-.69-1.57-.69-2.44 0-1.46.65-2.81 1.78-3.71.84-.67 1.9-1.04 2.97-1.04 2.62 0 4.75 2.13 4.75 4.75 0 .87-.24 1.72-.69 2.45-.24.42-.57.8-.95 1.12-.83.76-1.94 1.18-3.11 1.18-1.66 0-3.22-.88-4.06-2.31zm2.03-4.97a3.224 3.224 0 0 0-.75 4.2c.59 1 1.63 1.58 2.78 1.58.79 0 1.55-.29 2.13-.81.26-.22.48-.48.64-.76.32-.51.48-1.09.48-1.68 0-1.79-1.46-3.25-3.25-3.25-.74 0-1.44.25-2.03.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.54 19.57-2.11-2.11a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.11 2.11c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.401 19.6a.754.754 0 0 1 0-1.06l2.11-2.11c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.11 2.11c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBoxRemove);
export default __webpack_public_path__ + "static/media/vuesax-outline-box-remove.532befadb2c4e14174411e8597e7b11c.svg";
export { ForwardRef as ReactComponent };